import { FormContainer } from 'react-hook-form-mui';
import { useForm } from 'react-hook-form';
import { useCallback } from 'react';

import { useSnackbar } from 'notistack';
import { Box, Button, Stack, Typography } from '@mui/material';
import Http from '@/services/http';
import { IWorkshop } from '@/models/workshop-model';
import { useItemDrawer } from '@/contexts/drawer';

import WorkshopForm from '../components/workshop-form';

interface IUpdateWorkshopFormProps {
  workshop: IWorkshop;
}

const UpdateWorkshopForm: React.FC<IUpdateWorkshopFormProps> = ({
  workshop,
}) => {
  const form = useForm({
    defaultValues: workshop,
  });

  const { enqueueSnackbar } = useSnackbar();

  const drawerItem = useItemDrawer();

  const handleSubmit = useCallback(
    async (values: any) => {
      const { status, data } = await Http.put(
        `mechanical/${workshop._id}`,
        values
      );

      if (status === 200) {
        enqueueSnackbar('Oficina atualizada com sucesso!', {
          variant: 'success',
        });
        drawerItem.close(data);
      } else
        enqueueSnackbar('Ocorreu um erro ao atualizar a oficina!', {
          variant: 'error',
        });
    },
    [drawerItem, workshop._id, enqueueSnackbar]
  );

  return (
    <Box sx={{ p: 4, flexGrow: 1 }}>
      <Stack spacing={2} sx={{ height: '100%' }}>
        <Typography sx={{ fontSize: 20, fontWeight: 'bold' }}>
          ATUALIZAR {workshop.name}
        </Typography>
        <FormContainer
          formContext={form}
          FormProps={{
            style: { flexGrow: 1, display: 'flex', flexDirection: 'column' },
          }}
          onSuccess={handleSubmit}
        >
          <Box sx={{ p: 2, flexGrow: 1 }}>
            <WorkshopForm />
          </Box>
          <Stack direction="row" spacing={1}>
            <Button type="submit" variant="contained">
              Atualizar
            </Button>
            <Button onClick={() => drawerItem.close()}>Cancelar</Button>
          </Stack>
        </FormContainer>
      </Stack>
    </Box>
  );
};

export default UpdateWorkshopForm;
